import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Floor extends Bloc {

	constructor (src, ctx) {

		super("floor", src, ctx);
		this.f = (src, ins) => [src.master.run.floor];
		this.types = [];
	}
}